import script from "./FixedDownloadMoveButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FixedDownloadMoveButton.vue?vue&type=script&setup=true&lang=js"

import "./FixedDownloadMoveButton.vue?vue&type=style&index=0&id=6a813173&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a813173"]])

export default __exports__